import { useState, useCallback } from 'react';
import { createContainer } from 'unstated-next';
import mergeWith from 'lodash/mergeWith';
import isArray from 'lodash/isArray';
import useLocalStorageState from 'use-local-storage-state';
import { ResortInterface, ProductInterface } from 'ks-common';
import { NormalizedResortAddress } from 'utils/validators/addressMatcher';

export interface GlobalState {
  resortsList: ResortInterface[];
  normalizedResortAddresses: NormalizedResortAddress[];
  currentCategory: number;
}

const useGlobalState = () => {
  const [globalState, setGlobalState] =
    useLocalStorageState<Partial<GlobalState>>('globalStateStorage');
  const [allProducts, setAllProducts] = useState<ProductInterface[]>();

  const checkArray = (a: unknown, b: unknown) => (isArray(b) ? b : undefined);

  const updateGlobalState = useCallback((value: Partial<GlobalState>) => {
    setGlobalState(prev => ({ ...mergeWith(prev, value, checkArray) }));
  }, []);

  return {
    globalState,
    setGlobalState,
    updateGlobalState,
    allProducts,
    setAllProducts,
  };
};

export const GlobalStateContainer = createContainer(useGlobalState);
